"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = require("@react-pdf/renderer");
var get_1 = __importDefault(require("lodash/get"));
var React = __importStar(require("react"));
var Column_1 = __importDefault(require("../Column"));
var Row_1 = __importDefault(require("../Row"));
var style = renderer_1.StyleSheet.create({
    rootContainer: {
        border: 1,
        borderRadius: 3,
        padding: 5,
        marginTop: 2,
    },
    text: {
        fontFamily: "Quicksand",
        fontSize: 9,
    },
    columnHeaderText: {
        fontWeight: 700,
    },
    columnHeader: {
        flexGrow: 1,
        alignItems: "center",
        borderBottom: 0.5,
        justifyContent: "center",
    },
    cell: {
        alignItems: "center",
        flexGrow: 1,
        padding: 1,
    },
});
var renderCell = function (row, accessor) {
    if (typeof accessor === "string")
        return get_1.default(row, accessor, "");
    if (typeof accessor === "function")
        return accessor(row);
    return "";
};
var ResultsTable = function (_a) {
    var rows = _a.rows, columns = _a.columns;
    return (React.createElement(renderer_1.View, { style: style.rootContainer },
        React.createElement(Row_1.default, null, columns.map(function (_a) {
            var Header = _a.Header, width = _a.width;
            return (React.createElement(Column_1.default, { style: __assign(__assign({}, style.columnHeader), { width: width }), key: Header },
                React.createElement(renderer_1.Text, { style: [style.text, style.columnHeaderText] }, Header)));
        })),
        rows.map(function (row, rowIndex) { return (React.createElement(Row_1.default, { key: rowIndex, style: {
                backgroundColor: rowIndex % 2 === 0 ? "#fff" : "#e1e1e1",
                borderRadius: 3,
            } }, columns.map(function (_a, columnIndex) {
            var width = _a.width, accessor = _a.accessor;
            return (React.createElement(Column_1.default, { key: columnIndex, style: __assign(__assign({}, style.cell), { width: width, borderRight: columnIndex === columns.length - 1 ? 0 : 0.5 }) },
                React.createElement(renderer_1.Text, { style: style.text }, renderCell(row, accessor))));
        }))); })));
};
exports.default = ResultsTable;
//# sourceMappingURL=index.js.map